import React, { Fragment, useEffect } from 'react';

import {
    Input,
    InputLabel,
    InputAdornment,
    FormControlLabel,
    Checkbox,
    Card,
    CardContent,
    Button,
    FormControl
} from '@material-ui/core';

import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import LockTwoToneIcon from '@material-ui/icons/LockTwoTone';
import { useHistory } from 'react-router-dom';
import validate from 'validate.js';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { setSigninData, signIn, clearSigninData, setSignInAsSubuser } from 'eebac/reducers/signin';
import { VALIDATION_MESSAGES } from 'eebac/constants';
import AuthRedirect from 'eebac/routes/auth_redirect';
import { ROUTES_PATH_CONFIG } from 'eebac/config/routes';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import { setIsPasswordChanged } from 'eebac/reducers/forgot_password';

const validators = {
    Email: {
        presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        email: {
            message: VALIDATION_MESSAGES.INVALID
        }
    },
    Passwoard: {
        presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
    }
}

const StyledCard = withStyles(theme => ({
    root: {
        margin: 'auto',
        maxWidth: '500px',

    }
}))(props => <Card className="card-box mb-4" {...props} />);

function Signin(props) {
    const history = useHistory();

    const {
        setSigninData,
        userData,
        signIn,
        clearSigninData,
        setSignInAsSubuser,
        setIsPasswordChanged
    } = props;

    const [showPassword, setShowPassword] = React.useState(false);

    useEffect(() => {
        setIsPasswordChanged(false);
    }, []);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const setUserData = (key, value) => {
        if (value) {
            value = value.trim();
        }
        setSigninData([{ key: key, value: value }]);
    }

    const onSignIn = () => {
        setSigninData([{ key: 'emailError', value: '' }, { key: 'passwordError', value: '' }]);
        let errorObj = [];

        let errorMessage = validate.single(userData.email, validators.Email, { format: "flat" });
        if (errorMessage && errorMessage.length > 0) {
            errorObj.push({ key: 'emailError', value: errorMessage[0] });
        }

        errorMessage = validate.single(userData.password, validators.Passwoard, { format: "flat" });
        if (errorMessage && errorMessage.length > 0) {
            errorObj.push({ key: 'passwordError', value: errorMessage[0] });
        }

        if (errorObj.length > 0) {
            setSigninData(errorObj);
        } else {
            signIn();
        }
    }

    const redirectTo = path => {
        clearSigninData();
        history.push(path);
    }

    const signInAsSubUser = () => {
        setSignInAsSubuser(!userData.signinAsSubuser);
    }

    return (
        <Fragment>
            <AuthRedirect />
            <div style={{ padding: "70px 20px" }}>
                <StyledCard>
                    <div className="card-header">

                        <div className="card-header--title py-2 font-size-lg font-weight-bold text-center">
                            <div>
                                <a href="/">
                                    <img alt="eebac.com" src="/images/logo.png" style={{ width: "160px" }} />
                                </a>
                            </div>
                            {!userData.signinAsSubuser ? "SignIn" :
                                "SignIn as Subuser"}
                        </div>
                    </div>

                    <CardContent className="p-3">
                        <form className="px-5">
                            <div className="mb-3">
                                <FormControl className="w-100">
                                    <InputLabel htmlFor="input-with-icon-adornment">
                                        Email address
                                    </InputLabel>
                                    <Input
                                        error={userData.emailError ? true : false}
                                        fullWidth
                                        id="input-with-icon-adornment"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <MailOutlineTwoToneIcon />
                                            </InputAdornment>
                                        }

                                        value={userData.email}
                                        onChange={(e) => { setUserData('email', e.target.value) }}
                                    />
                                </FormControl>
                            </div>
                            <div className="mb-3">
                                <FormControl className="w-100">
                                    <InputLabel htmlFor="standard-adornment-password">
                                        Password
                                    </InputLabel>
                                    <Input
                                        error={userData.passwordError ? true : false}
                                        fullWidth
                                        type={showPassword ? 'text' : 'password'}
                                        id="standard-adornment-password"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <LockTwoToneIcon />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }

                                        value={userData.password}
                                        onChange={(e) => { setUserData('password', e.target.value) }}
                                    />
                                </FormControl>
                            </div>
                            <div className="w-100">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={userData.rememberMe}
                                            onChange={() => { setUserData('rememberMe', !userData.rememberMe) }}
                                            value="rememberMe"
                                            color="primary"
                                        />
                                    }
                                    label="Remember me"
                                />
                            </div>
                            <div className="text-center">
                                <Button
                                    color="primary"
                                    variant="contained"
                                    size="large"
                                    className="my-2"
                                    onClick={onSignIn}>
                                    Sign in
                                  </Button>
                            </div>
                            <div className="text-center">
                                <Button color="primary"
                                    className="m-2 text-primary px-0"
                                    onClick={() => redirectTo(ROUTES_PATH_CONFIG.APP.forgot_password)}>

                                    <span>Forgot Password?</span>
                                </Button>
                                |
                                <Button color="primary"
                                    className="m-2 text-primary px-0"
                                    onClick={() => redirectTo(ROUTES_PATH_CONFIG.APP.register)}>
                                    <span>Create an Account</span>
                                </Button>
                            </div>
                            {false && <div className="text-center">
                                <Button color="primary"
                                    className="m-2 text-primary px-0"
                                    onClick={signInAsSubUser}>
                                    <span>
                                        {!userData.signinAsSubuser ? "SignIn as Subuser" :
                                            "SignIn as Root User"}
                                    </span>
                                </Button>
                            </div>}
                        </form>
                    </CardContent>
                </StyledCard>
            </div>
        </Fragment>
    );
}


const mapStateToProps = state => ({
    userData: state.SIGNIN_DATA,
});

const mapDispatchToProps = dispatch => ({
    setSigninData: data => dispatch(setSigninData(data)),
    signIn: () => dispatch(signIn()),
    clearSigninData: () => dispatch(clearSigninData()),
    setSignInAsSubuser: (signinAsSubuser) => dispatch(setSignInAsSubuser(signinAsSubuser)),
    setIsPasswordChanged: (flag) => dispatch(setIsPasswordChanged(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(Signin);